import { usersFragment } from "src/lib/queries/integrations";

export const PAYMENT_METHOD_QUERY = gql`
  query GetPaymentMethod {
    paymentMethod {
      type
      last4
      expMonth
      expYear
    }
  }
`;

export const PAYMENT_METHOD_URL_QUERY = gql`
  query GetPaymentMethodUrl {
    paymentMethodUrl
  }
`;

export const TAKEOVER_BILLING_MUTATION = gql`
  mutation TakeoverBillingMutation($id: String!) {
    takeoverBilling(id: $id) {
      id
      ...UsersFragment
    }
  }

  ${usersFragment}
`;

export const INVOICES_QUERY = gql`
  query GetInvoices {
    invoices {
      id
      number
      createdAt
      status
      amount
      month
      externalId
      downloadUrl
    }
  }
`;

export const INVOICE_DOWNLOAD_URL_QUERY = gql`
  query GetInvoiceDownloadUrl($invoiceId: String!) {
    invoiceDownloadUrl(invoiceId: $invoiceId)
  }
`;

export const CONFIRM_PAYMENT_METHOD_MUTATION = gql`
  mutation ConfirmPaymentMethodMutation {
    confirmPaymentMethod
  }
`;

export const CURRENT_USAGE_QUERY = gql`
  query GetCurrentUsage {
    currentUsage {
      integrationId
      storeName
      description
      amountCents
      billableDays
      activeDaysCount
      trialDaysApplied
      kind
      volumeBandKey
      pricingSource
      trailingOrderCount
      averageMonthlyOrders
      monthlyPriceCents
      advisoryStatus
      advisoryMonthlyPriceCents
      advisoryCancelAt
      advisoryQuotedAddons
      advisoryQuotedCustomServices
    }
  }
`;

export const REQUEST_STORE_ADVISORY_MUTATION = gql`
  mutation RequestStoreAdvisoryMutation($input: StoreAdvisoryRequestInput!) {
    requestStoreAdvisory(input: $input) {
      id
      status
    }
  }
`;

export const ACCEPT_STORE_ADVISORY_QUOTE_MUTATION = gql`
  mutation AcceptStoreAdvisoryQuoteMutation($integrationId: String!) {
    acceptStoreAdvisoryQuote(integrationId: $integrationId) {
      id
      status
      quotedMonthlyPriceCents
      activatedAt
    }
  }
`;

export const CANCEL_STORE_ADVISORY_MUTATION = gql`
  mutation CancelStoreAdvisoryMutation($integrationId: String!) {
    cancelStoreAdvisory(integrationId: $integrationId) {
      id
      status
      cancelAt
    }
  }
`;
